import { omit } from 'lodash-es';

import { BASE_SIZE } from '../constant';

export const STATUS_BADGE_SIZE = omit(BASE_SIZE, 'LG');

export enum STATUS_BADGE_VARIANT {
  AI_ANNO = 'aiAnno',
  COMPLETED = 'completed',
  FAILED = 'failed',
  IN_PROGRESS = 'inProgress',
  IN_REVIEW = 'inReview',
  NOT_STARTED = 'notStarted',
  READY = 'ready',
  REJECTED = 'rejected',
  SUBMITTED = 'submitted',
}
